import { useMemo } from 'react';
import { useAppSelector } from './reduxHooks';
import { selectCurrentUser } from '../features/auth/authSlice';

export interface ClienteAsignado {
    id: number;
    nombre: string;
}

export interface ContratoAsignado {
    id: number;
    nombre: string;
}

export interface OrganismoAsignado {
    id: number;
    nombre: string;
    idOrganismoCentral?: number;
}

// Cliente, contratos y organismos asignados al Supervisor, que vienen en el usuario logueado.
// Los filtros de ROAM y Visitas ofrecen solo estos; con uno solo, va precargado y grisado (SMP-636)
const useAsignacionSupervisor = () => {
    const currentUser = useAppSelector(selectCurrentUser);

    const cliente = useMemo<ClienteAsignado | null>(
        () =>
            currentUser?.organizacion?.id
                ? { id: currentUser.organizacion.id, nombre: currentUser.organizacion.nombre }
                : null,
        [currentUser?.organizacion?.id, currentUser?.organizacion?.nombre]
    );

    const contratos = useMemo<ContratoAsignado[]>(
        () =>
            (currentUser?.contrato ?? []).map((contrato: any) => ({
                id: contrato.id,
                nombre: contrato.nombre
            })),
        [currentUser?.contrato]
    );

    const organismos = useMemo<OrganismoAsignado[]>(
        () =>
            (currentUser?.organismos ?? []).map((organismo: any) => ({
                id: organismo.id,
                nombre: organismo.nombre,
                idOrganismoCentral: organismo.idOrganismoCentral
            })),
        [currentUser?.organismos]
    );

    return {
        cliente,
        contratos,
        organismos,
        idContratoUnico: contratos.length === 1 ? contratos[0].id : undefined,
        idOrganismoUnico: organismos.length === 1 ? organismos[0].id : undefined
    };
};

export default useAsignacionSupervisor;
